module.exports = __webpack_public_path__ + "static/img/preview-3.4b8658e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/zombs/preview-3.png
// module id = xGl3
// module chunks = 35